export default __webpack_public_path__ + "static/media/plus.94b3854c.svg";